import React, { useEffect } from 'react';
import { useBroadcast } from '../common/broadcast-channel/use-broadcast';
import { useApplicationType } from '../common/hooks/use-application-type';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { useSyncPowerSaveBlocker } from '../electron-bridge/use-sync-power-save-blocker';
import { ElectronWindowsContext, ElectronWindows } from './electron-windows-context';

export function ElectronWindowsProvider(props: {
    children: React.ReactElement;
}): React.ReactElement {
    const { isElectronRewrite } = useApplicationType();
    const [electronWindows, setElectronWindows] = React.useState<ElectronWindows>([]);

    useSyncPowerSaveBlocker();

    useEffect(() => {
        if (electronBridge && 'isElectronRewrite' in electronBridge) {
            electronBridge.onResync(() => {
                window.location.reload();
            });
        }
    }, []);

    const { postMessage } = useBroadcast('legacy-store-broadcast', (message) => {
        if (message.type === 'RESYNC') {
            window.location.reload();
        }
        if (message.type === 'SET_WORKSPACE_WINDOWS') {
            setElectronWindows(message.payload);
        }
    });

    React.useEffect(() => {
        postMessage({ type: 'GET_WORKSPACE_WINDOWS' });
    }, [postMessage, setElectronWindows, isElectronRewrite]);
    return (
        <ElectronWindowsContext.Provider value={electronWindows}>
            {props.children}
        </ElectronWindowsContext.Provider>
    );
}
